import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-link-liberado',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './link-liberado.html',
  styleUrls: ['./link-liberado.scss']
})
export class LinkLiberado {

  constructor(private router: Router) {}

  irParaDefinirSenha() {
    this.router.navigate(['/auth/primeiro-acesso/definir-senha']);
  }
}
